import React from "react";

import '../css/ShowCase.css';
import { getOSSImage } from "./Utils";

const titleImage = getOSSImage('zi_title_anli.png');
const caseImage = getOSSImage('anli.png');

export default function ShowCase() {
    return(
        <div id="showcase" className="show-case-container">
            <img className="show-case-title" alt="sc-title" src={titleImage}/>
            <img className="show-case-image" alt="sc-image" src={caseImage}/>
        </div>
    )
}